import { render, staticRenderFns } from "./ShowEdit.vue?vue&type=template&id=ab5c3382&scoped=true"
import script from "./ShowEdit.vue?vue&type=script&lang=js"
export * from "./ShowEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5c3382",
  null
  
)

export default component.exports